import { renderDate } from '../utility/personTabGridHelper';

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DEFAULT_VALUES = {
  DNASampleID: '',
  Taken: null,
  ptsTakenByPersonID: null,
  Type: '',
  Method: '',
  Reason: '',
  Status: '',
  ptsCrimeLabPlaceID: null,
  CrimeLabSentDateTime: null,
  Notes: '',
};

export const DNA_SAMPLE_GRID_COLUMNS = [
  { field: 'DNASampleID', headerName: 'Sample ID', width: 140 },
  { field: 'Taken', headerName: 'Taken Date', width: 180, valueFormatter: renderDate },
  { field: 'TakenBy', headerName: 'Taken By', width: 170 },
  { field: 'Type', headerName: 'Type', width: 150 },
  { field: 'Method', headerName: 'Method', width: 150 },
  { field: 'Reason', headerName: 'Reason', width: 160 },
  { field: 'Status', headerName: 'Status', width: 140 },
  { field: 'CrimeLab', headerName: 'Crime Lab', width: 180 },
  {
    field: 'CrimeLabSentDateTime',
    headerName: 'Sent Date',
    width: 180,
    valueFormatter: renderDate,
  },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
